import { render, staticRenderFns } from "./approvalFormsView.vue?vue&type=template&id=8ac4cefa&scoped=true"
import script from "./approvalFormsView.vue?vue&type=script&lang=js"
export * from "./approvalFormsView.vue?vue&type=script&lang=js"
import style0 from "./approvalFormsView.vue?vue&type=style&index=0&id=8ac4cefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac4cefa",
  null
  
)

export default component.exports